import { TabSelectItem } from "~/components/TabSelect";

// // // //

export interface LeagueTableRowData {
    group: {
        id: number;
        type: string;
        name: string;
        slug: string;
        color: string | null;
        icon_url?: string | null;
        linkTo?: {
            href: string;
            analyticsLabel: string;
            openInNewTab?: boolean;
        } | null;
    };
    value: number;
    value_7d_ago: number;
    value_7d_change: number;
    rowIndex: number;
    asset_count?: number | null;
    market_share_pct: number;
    market_share_pct_30d_ago: number;
    market_share_pct_30d_change: number;
    pct_transferable?: number | null;
}

export enum LeagueTableGroupTypes {
    assets = "assets",
    tokens = "tokens",
    assetClasses = "asset_classes",
    issuers = "issuers",
    networks = "networks",
    parentNetworks = "parent_networks",
    jurisdictionCountries = "jurisdiction_countries",
    managers = "managers",
    platforms = "platforms",
    realEstateCountries = "real_estate_countries",
    peggedAssets = "pegged_assets",
    peggedAssetType = "pegged_asset_type",
    assetType = "asset_type",
    auditor = "auditor",
    cryptoBroker = "crypto_broker",
    cryptoCustodian = "crypto_custodian",
    fundAdministrator = "fund_administrator",
    payingAgent = "paying_agent",
    subAdvisor = "sub_advisor",
    traditionalBroker = "traditional_broker",
    transferAgent = "transfer_agent",
    exchangeAgent = "exchange_agent",
    traditionalCustodian = "traditional_custodian",
}

interface LeagueTableTabData {
    groupColumnLabel: string;
    valueColumnLabel: string;
    rows: LeagueTableRowData[];
    groupType: LeagueTableGroupTypes;
}

export type LeagueTableTab = TabSelectItem<LeagueTableTabData>;

export interface LeagueTableTabsByDistributionType {
    all: LeagueTableTab[];
    distributed: LeagueTableTab[];
    represented: LeagueTableTab[];
}
